import type { CaseForPharmacy } from "@omony/domain";
import type { T } from "./t.js";

type VitalValue = CaseForPharmacy["vitals"][number]["value"];

/** Vitalwert als Text mit Einheit (Apotheke und Leitstand) */
export function vitalText(t: T, v: VitalValue) {
  switch (v.type) {
    case "rr":
      return t("vital.fmt.rr", { sys: v.sys, dia: v.dia });
    case "puls":
      return t("vital.fmt.puls", { value: v.value });
    case "temp":
      return t("vital.fmt.temp", { value: v.value });
    case "spo2":
      return t("vital.fmt.spo2", { value: v.value });
    case "blutzucker":
      return t("vital.fmt.blutzucker", { value: v.value });
    case "schnelltest":
      return t("vital.fmt.schnelltest", { test: v.test, result: t(`vital.schnelltest.${v.ergebnis}`) });
  }
}
